import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	nearpod_picker: {
		audio: null,
		audio_recorder: null,
		gif: null,
		image: null,
		pdf: null,
		video: null,
		web: null,
	},
}

function nearpodPickerPick(state, action) {
	const newState = {...state}
	newState.nearpod_picker = {...state.nearpod_picker}
	newState.nearpod_picker[action.pickerType] = action.pick
	return newState
}

const playgroundReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.PLAYGROUND_NEARPOD_PICKER_PICK: {
			return nearpodPickerPick(state, action)
		}
		default: return state
	}
}

export default playgroundReducer
